import StateObserver from 'src/StateObserver';
import PopupCheats, { Item } from 'src/game/cheats/PopupCheats';
import { CheatData } from 'src/game/cheats/cheats.sequences';
import { closeAllPopups, closePopup } from 'src/lib/popups/popupOpenClose';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import PopupMatch2MagicLamps from './PopupMatch2MagicLamps';

const MATCH2_MAGIC_LAMPS = 'match2 Magic Lamps';

const list = () => {
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_MAGIC_LAMPS] = [
    {
      text: 'Reset Magic Lamps',
      color: 'secondary',
      cheat: async () => {
        StateObserver.invoke.cheat_magicLampsReset();
        closeAllPopups();
      },
    },
    {
      text: 'Go To Round #10',
      color: 'secondary',
      cheat: async () => {
        if (!PopupMatch2MagicLamps.instance?.playing) return;
        StateObserver.invoke.cheat_magicLampsGoToRound({ round: 10 });
        PopupMatch2MagicLamps.instance?.refresh();
        closePopup('popupCheats');
      },
    },
    {
      text: 'Go To Round #20',
      color: 'secondary',
      cheat: async () => {
        if (!PopupMatch2MagicLamps.instance?.playing) return;
        StateObserver.invoke.cheat_magicLampsGoToRound({ round: 20 });
        PopupMatch2MagicLamps.instance?.refresh();
        closePopup('popupCheats');
      },
    },
    {
      text: 'Go To Round #25',
      color: 'secondary',
      cheat: async () => {
        if (!PopupMatch2MagicLamps.instance?.playing) return;
        StateObserver.invoke.cheat_magicLampsGoToRound({ round: 25 });
        PopupMatch2MagicLamps.instance?.refresh();
        closePopup('popupCheats');
      },
    },
    {
      text: 'Go To Round #30',
      color: 'secondary',
      cheat: async () => {
        if (!PopupMatch2MagicLamps.instance?.playing) return;
        StateObserver.invoke.cheat_magicLampsGoToRound({ round: 30 });
        PopupMatch2MagicLamps.instance?.refresh();
        closePopup('popupCheats');
      },
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  switch (args.key) {
    case MATCH2_MAGIC_LAMPS:
      args.title.updateOpts({
        width: args.item.style.width - 40,
        height: 20,
        y: 8,
        align: 'center',
      });
      args.popup.createVerticalButtons(args.item, args.setting);
      break;
  }
};

export const match2MagicLampsCheats = {
  list,
  ui,
};
